import type { Condition } from './types'

export const valuesFilled = (v: string | Date | any[]) => (Array.isArray(v) ? !!v.length : !!v)

export const isActiveFilter = (value: string | Date | any[], selectedCondition: Condition) =>
  selectedCondition.valueRequired ? valuesFilled(value) : !!selectedCondition.label
